let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gar5H")).then(() => parcelRequire('ldzQw'));